import useAd from 'lib/hooks/useAd';
import ScreenSize from 'lib/ScreenSize';
import { Targeting } from 'lib/GoogleAds';
import Container from './Container';

interface AdConfig {
  screenSizes?: Array<ScreenSize>;
  targeting: Targeting;
  dimensions: Array<Array<number>> | Array<string>;
}

export interface AdProps {
  placeholderSize?: Array<number>;
  adConfig: AdConfig;
  className?: string;
  load?: boolean;
}

export default function Ad({
  placeholderSize = [],
  adConfig,
  load = true,
  ...props
}: AdProps): JSX.Element {
  const { isShown, elementId } = useAd(adConfig, load);
  const screenSizes = adConfig.screenSizes || [];

  return (
    <Container
      elementId={elementId}
      placeholderSize={placeholderSize}
      isShown={isShown}
      screenSizes={screenSizes}
      {...props}
    />
  );
}
